import controller from './wf-icon.controller';
import template from './wf-icon.html';

export default {
	controller,
	template,
	bindings: {
		color: '<?',
		multiple: '<?',
	},
};
